import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import './style.css'
import { APP_PATH } from '../../appConfig';
// import { useLocation } from 'react-router-dom/cjs/react-router-dom';

// https://admin.shopify.com/store/develop-apps/charges/livetestrates/pricing_plans

const Navbar = props => {
    const location = useLocation()
    const { shopName, store } = useSelector(state => state.ConfigReducer)
    const appName = APP_PATH
    const dynamicShopName = shopName || store?.domain?.replace('.myshopify.com', '')
    const plansUrl = `https://admin.shopify.com/store/${dynamicShopName}/charges/${appName}/pricing_plans`
    const [ActiveIndex, setActiveIndex] = useState(0)
    useEffect(() => {
        const index = props.options.findIndex(option => option.url === location.pathname)
        setActiveIndex(index)
    }, [location.pathname])

    const list = props.options.map((option, i) => {
        if (option.url === "/plans") {
            return <a
                className={`${option.primary ? 'Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter' : 'li'}${option.right ? " float-right" : ""}`}
                key={i}
                href={plansUrl}
                target='_top'
                rel="noopener noreferrer"
                onClick={() => setActiveIndex(i)}
            >
                <li className={option.alwaysActive ? "active" : ""}>
                    {option.text}
                </li>
            </a>
        }
        if (option.external) {
            return <a className={`external${option.right ? " float-right" : ""}`} href={option.url} target='_blank' rel="noopener noreferrer" key={i}>{option.text}</a>
        }
        return <Link
            className={`${option.primary ? 'Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter' : 'li'}${option.right ? " float-right" : ""}`}
            key={i}
            to={option.url}
            onClick={() => setActiveIndex(i)}
        >
            <li className={(ActiveIndex === i && option.url !== "/plans") || option.alwaysActive ? "active" : ""}>
                {option.text}
            </li>
        </Link>
    })
    return <ul className="nav">{list}</ul>
}
export default Navbar
